import { Star } from "phosphor-react"

const StarRating = ({ rating, onRatingChange }) => {
  return (
    <div className="flex items-center">
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          size={24} 
          className={`w-6 h-6 cursor-pointer ${star <= rating ? "text-yellow-400 fill-current" : "text-gray-300"}`}
          onClick={() => onRatingChange(star)}
        />
      ))}
    </div>
  )
}

export default StarRating

